// This file was automatically generated from ptdata.ptIntolerances.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.ptIntolerances');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptIntolerances.documentedAsNoneSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('No known drug intolerances');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptIntolerances.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.intolerance.name), (opt_data.reaction) ? ' = ' + soy.$$escapeHtml(opt_data.reaction) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptIntolerances.patientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
  } else {
    if (! opt_data.actives.length) {
      output.append('HAVE NOT ASKED');
    } else {
      var aList22095 = opt_data.actives;
      var aListLen22095 = aList22095.length;
      for (var aIndex22095 = 0; aIndex22095 < aListLen22095; aIndex22095++) {
        var aData22095 = aList22095[aIndex22095];
        el8.template.ptdata.ptIntolerances.summary(aData22095, output);
        output.append((! (aIndex22095 == aListLen22095 - 1)) ? (opt_data.actives.length > 5 && aIndex22095 == 4) ? '<span class="comma-separator">,</span> ' : ', ' : '', (opt_data.actives.length > 5) ? ((aIndex22095 == 4) ? '<a class="more-intols-trigger">+ ' + soy.$$escapeHtml(opt_data.actives.length - 5) + ' more</a> <span class="more-intols">' : '') + ((aIndex22095 == aListLen22095 - 1) ? ' <a class="less-intols-trigger">show less</a></span>' : '') : '');
      }
    }
  }
  if (!opt_sb) return output.toString();
};
